import React from 'react'
import slugify from 'react-slugify'
import { VuiCollapsibleMenu } from '@topkamera/viso-ui'
import { SOLUTION_ACCENT } from 'utils/constants'
import { routeMapping } from 'routes'

const SideBarMainNav = ({
  unreadCount,
  updateNotificationDisplay,
  workspace
}) => {

  return (
    <VuiCollapsibleMenu
      onClick={(id) => {
        id === 'notifications' && updateNotificationDisplay(true)
      }}
      items={[
        {
          id: 'main',
          color: 'accent0',
          hasPermissions: true,
          actions: [
            {
              id: 'home',
              to: '/',
              color: 'accent0',
              label: 'Home',
              icon: 'home',
              hasPermissions: true
            },
            {
              id: 'notifications',
              color: 'accent0',
              label: 'Notifications',
              icon: unreadCount ? 'alertAccent' : 'noAlert',
              iconAccess: 'accent0',
              ...(unreadCount ? {
                badge: {
                  color: 'accent0',
                  text: unreadCount > 9 ? '+9' : unreadCount
                }
              } : {}),
              hasPermissions: true,
            },
            {
              id: 'settings',
              icon: 'settings',
              hasPermissions: true,
              color: SOLUTION_ACCENT,
              to: `/${workspace && slugify(workspace.name)}${routeMapping.SETTINGS.path}`,
              label: 'Settings',
            },
          ]
        }
      ]}
    />
  )
}

export default SideBarMainNav